//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('checkLists', {
//        templateUrl: 'views/components/views/checkLists/checkLists.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'checkListsService', 'rememberService', function (stateService, utilityService, checkListsService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            let variableNames = {
//                searchtext: ''
//            };

//            vm.model = {
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') }
//                ],
//                setting: {},
//                itemsListChecks: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTIONS

//            async function loadSetting() {
//                vm.model.setting = (await checkListsService.getSetting())[0];
//            }

//            async function loadChecks() {
//                vm.model.itemsListChecks = await checkListsService.listChecks();
//            }

//            // #endregion LOAD PROCEDURE FUNCTIONS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    switch (key) {
//                    	case 'searchtext':
//                    		variableNames[key] = 'w.checklists.searchtext';
//                    		break;
//                    	default:
//                    		variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                    		break;
//                    }
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region RESET BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'searchtext':
//                        vm.model.setting.searchtext = '';

//                        if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region MULTI BUTTON DIRECTION FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'checklist':
//                        go({ checklist_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI BUTTON DIRECTION FUNCTIONS

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext) !== true) return;

//                        if (vm.model.setting.searchtext > '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion ON BLUR MULTI FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                        vm.model.setting.searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadSetting();
//                loadChecks();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
